import {createSelector} from '@reduxjs/toolkit';

import {getAllChannels, getChannelSetInCurrentTeam} from 'mattermost-redux/selectors/entities/channels';
import {type Channel} from '@mattermost/types/channels';

export const getArchivedChannelsMap = createSelector(
    getAllChannels,
    getChannelSetInCurrentTeam,
    (channels, currentTeamChannelSet): Record<string, Channel> => {
        const archivedChannelsMap: Record<string, Channel> = {};

        currentTeamChannelSet.forEach((id) => {
            const channel = channels[id];

            if (channel && channel.delete_at > 0) {
                archivedChannelsMap[channel.id] = channel;
            }
        });

        return archivedChannelsMap;
    },
);
